import { Leaf, Wheat, Sprout } from 'lucide-react';

const badges = {
  vegetarian: {
    label: 'V',
    fullLabel: 'Vegetarisch',
    icon: Leaf,
    className: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
  },
  vegan: {
    label: 'VG',
    fullLabel: 'Vegan',
    icon: Sprout,
    className: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
  },
  glutenFree: {
    label: 'GF',
    fullLabel: 'Glutenfrei',
    icon: Wheat,
    className: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
  }
};

export default function DietaryBadge({ type, showLabel = false, size = 'sm' }) {
  const badge = badges[type];
  if (!badge) return null;

  const Icon = badge.icon;
  const sizeClasses = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';

  return (
    <span
      className={`
        inline-flex items-center gap-1
        font-semibold rounded-full
        ${badge.className}
        ${sizeClasses}
      `}
      title={badge.fullLabel}
    >
      <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />
      {showLabel ? badge.fullLabel : badge.label}
    </span>
  );
}
